import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll,postApproval } from "./invoiceOldAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  approval: [],
};

export const fetchAll = createAsyncThunk("invoiceOld/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const createApproval = createAsyncThunk(
  "invoiceOld/createApproval",
  async (payload) => {
    const response = await postApproval(payload);
    return response.data;
  }
);

export const invoiceOldSlice = createSlice({
  name: "invoiceOld",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetData, setSelected, setApproval } = invoiceOldSlice.actions;

export const selectData = (state) => state.invoiceOld.data;
export const selectLoading = (state) => state.invoiceOld.loading;
export const selectError = (state) => state.invoiceOld.error;
export const selectPageNo = (state) => state.invoiceOld.pageNo;
export const selectPageSize = (state) => state.invoiceOld.pageSize;
export const selectTotalRecord = (state) => state.invoiceOld.totalRecord;
export const selectSelected = (state) => state.invoiceOld.selected;
export const selectApproval = (state) => state.invoiceOld.approval;

export default invoiceOldSlice.reducer;
